import { createSlice } from '@reduxjs/toolkit';
import { DTODiffusionModelsTablePageSettingsUD } from '@shared/dto/+model/table/dto_diffusion_models_table_page_settings_ud';
import { DTODiffusionModelsTableUD } from '@shared/dto/+model/table/dto_diffusion_models_table_ud';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../_base/LOCAL__global_reset';
import { init_local_ml_asset_reservation_delete } from './local_ml_asset_reservations_delete';
import { init_local_ml_asset_reservations_update_active } from './local_ml_asset_reservations_update_active';
import { init_local_ml_asset_reservations_upsert } from './local_ml_asset_reservations_upsert';
import { init_local_ml_asset_set_current_table_page_settings } from './local_ml_asset_set_current_table_page_settings';
import { init_local_ml_asset_upsert_model } from './local_ml_asset_upsert_model';
import { init_local_ml_asset_upsert_table_page } from './local_ml_asset_upsert_table_page';
import { init_local_ml_asset_upsert_table_without_pages } from './local_ml_asset_upsert_table_without_pages';
import { init_remote_ml_asset_get_by_id } from './remote_ml_asset_get_by_id';
import { init_remote_ml_asset_load_page_items } from './remote_ml_asset_load_page_items';
import { init_remote_ml_asset_rent_or_prolongate } from './remote_ml_asset_rent';
import { StateMLAsset } from './state_ml_asset';

const initialState: StateMLAsset = {
  ml_assets_map: new Map(),

  reservations_current_workspace_active_map: new Map(),

  reservations_map_all: new Map(),

  models_loading_in_progress: new Set(),

  page_settings_loading_in_progress: new Set(),

  current_table_page_settings: new DTODiffusionModelsTablePageSettingsUD().clone({
    filter_floating_point_precision: '',
    filter_base_model: '',
    filter_query: '',
    filter_type: '',
    filter_show_only_used: false,

    index_page: 0,
  }),
  current_table: DTODiffusionModelsTableUD.CREATE_STUB(),
  tables_map: new Map(),
};

export const slice_ml_asset = createSlice({
  name: ENUM__redux_slice.ML_ASSET,
  initialState,
  reducers: {
    upsert_model: init_local_ml_asset_upsert_model,
    upsert_table_without_pages: init_local_ml_asset_upsert_table_without_pages,
    upsert_table_page: init_local_ml_asset_upsert_table_page,
    set_current_table_page_settings: init_local_ml_asset_set_current_table_page_settings,

    reservations_delete: init_local_ml_asset_reservation_delete,
    reservations_upsert: init_local_ml_asset_reservations_upsert,
    reservations_update_active: init_local_ml_asset_reservations_update_active,
  },

  extraReducers: builder => {
    init_remote_ml_asset_get_by_id(builder);
    init_remote_ml_asset_load_page_items(builder);
    init_remote_ml_asset_rent_or_prolongate(builder);

    builder.addCase(LOCAL__global_reset, state => initialState);
  },
});
